import { useQuery } from "@tanstack/react-query";
import { getAirline } from "../../api/apiAirlines";

const QUERY_KEY = ["airlines"];

const useGetAirline = (id) => {
  const {
    data,
    isLoading,
    isError,
    error,
    isFetching
  } = useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => getAirline(id),
    enabled: !!id,
  });

  return {
    isLoading,
    isFetching,
    error: isError ? error : null,
    airline: data?.data || null,
  };
};

export default useGetAirline;
